export default "__VITE_ASSET__O5sxqvU4__"